import { QueryKey, MutationKey } from '@tanstack/react-query';

export const corpGroupsQueryKeys: QueryKey = ['corp', 'groups', 'query'];
export const groupServiceBriefTags: string[] = ['group', 'service', 'brief'];

export const createGroupMutationKey: MutationKey = ['group', 'mutation', 'create'];
export const updateGroupMutationKey: MutationKey = ['group', 'mutation', 'update'];
export const deleteGroupMutationKey: MutationKey = ['group', 'mutation', 'delete'];
